<template>
  <hm-content title="">
    <div class="add-goods-container">
      <hm-step
        :steps="steps"
        :scroll="true"
        :step="currentStep"
        @scroll="windowScroll"
      ></hm-step>
      <el-scrollbar :style="{ height: scrollHeight + 'px' }">
        <div class="pvw flex flex-warp">
          <div class="pvws">
            <div id="audio_btn" class="rotate">
              <audio
                :src="ruleForm.gameBgm"
                autoplay="true"
                loop="loop"
                id="media"
                preload="true"
              ></audio>
            </div>

            <img
              class="pvwimg"
              style="width:400px;height:667px"
              :src="listHeaderImgUrl"
              alt=""
            />
            <div class="describe">
              <p>已有 {{ 0 }}人参与</p>
              <p>您今天还有 {{ 3 }}次抽奖机会</p>
            </div>
          </div>

          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="product-ruleForm"
          >
            <div id="base">1.基本信息</div>
            <el-form-item label="活动标题" prop="gameName">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.gameName"
                placeholder="请输入活动标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动时间段选择" prop="activityDate">
              <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                v-model="ruleForm.activityDate"
                type="datetimerange"
                :picker-options="pickerOptions"
                align="right"
                start-placeholder="活动开始时间"
                end-placeholder="活动结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="活动分享文案" prop="gameShareContent">
              <el-input
                :maxlength="30"
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.gameShareContent"
                placeholder="请输入活动分享文案，30字以内"
              ></el-input>
            </el-form-item>
            <el-form-item label="背景音乐链接" prop="gameBgm">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model="ruleForm.gameBgm"
                placeholder="请输入音乐链接/音乐网络地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="主图：" prop="mainImgUrl">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                v-if="show"
                noCircle
                noSquare
                :width="750"
                :height="1334"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mallDecoration' }"
                :url="listHeaderUrl"
                img-format="png"
              ></my-upload>
              <!-- <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                noCircle
                noSquare
                :params="{ fileDir: 'mallDecoration' }"
                :headers="{ 'X-Access-Token': $token }"
                :width="750"
                :height="1334"
                :url="listHeaderUrl"
                img-format="png"
              ></my-upload> -->
              <el-button
                type="primary"
                size="small"
                v-show="!listHeaderImgUrl"
                @click="toggleShow"
                >上传</el-button
              >
              <span class="form-tip">图片尺寸建议750x1334（最多上传一张）</span>
              <div class="priview" v-if="listHeaderImgUrl">
                <img :src="listHeaderImgUrl" alt="主图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove">删除</el-button>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="活动规则说明" prop="gameRuleRemark">
              <hm-rich-editor
                v-model="ruleForm.gameRuleRemark"
                :html="ruleForm.gameRuleRemark"
              />
            </el-form-item>

            <el-form-item label="虚拟参与人数" prop="visualJoinNum">
              <span>在实际参与人数基础上增加</span
              ><el-input
                style="width: 100px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.visualJoinNum"
                placeholder="请输入数字"
              ></el-input
              >人
            </el-form-item>
            <div id="gameRule">{{ steps.length === 3 ? 2 : 2 }}活动规则</div>

            <el-form-item label="抽奖限制" prop="drawType">
              <template>
                <div>
                  <el-radio v-model="rule.drawType" label="total">
                    <span>总抽奖限制,限制活动时间,每人最多抽奖</span>
                    <el-input
                      :disabled="this.rule.drawType !== 'total'"
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="rule.drawPrizeNumTotal"
                      placeholder="请输入数字"
                    ></el-input>
                    <span>次,每人中奖上限</span>
                    <el-input
                      :disabled="this.rule.drawType !== 'total'"
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="rule.eachWinningUpperLimitTotal"
                      placeholder="请输入数字"
                    ></el-input>
                  </el-radio>
                </div>
                <div>
                  <el-radio v-model="rule.drawType" label="daily">
                    <span>每日抽奖限制,每人每日抽奖</span>
                    <el-input
                      :disabled="this.rule.drawType !== 'daily'"
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="rule.drawPrizeNumDaily"
                      placeholder="请输入数字"
                    ></el-input>
                    <span>次,每人中奖上限</span>
                    <el-input
                      :disabled="this.rule.drawType !== 'daily'"
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="rule.eachWinningUpperLimitDaily"
                      placeholder="请输入数字"
                    ></el-input>
                  </el-radio>
                </div>
              </template>
            </el-form-item>
            <el-form-item label="活动分享文案" prop="drawType">
              <div class="table game-select">
                <div class="table-header flex">
                  <div class="flex-1 text-center">奖项</div>
                  <div class="flex-1 text-center">奖品类型</div>
                  <div class="flex-1 text-center">奖品内容</div>
                  <div class="flex-1 text-center">奖品名称</div>
                  <div class="flex-1 text-center">奖品数量</div>
                  <div class="flex-1 text-center">优先级</div>
                  <div class="flex-1 text-center">操作</div>
                </div>
                <div class="table-body">
                  <div
                    class="flex table-row item-center"
                    v-for="(item, index) in rule.turntablePrizeRuleList"
                    :key="index"
                  >
                    <div class="flex-1 text-center">
                      <el-input
                        style="width:100px"
                        v-model.trim="item.rankingSeqNum"
                        size="small"
                      ></el-input>
                    </div>
                    <div class="flex-1 text-center">
                      <el-select
                        clearable
                        class="mr10 "
                        size="small"
                        v-model="item.prizeType"
                        placeholder="请选择奖品类型"
                      >
                        <el-option label="积分" value="1"></el-option>
                        <el-option label="优惠劵" value="2"></el-option>
                        <el-option label="实物" value="3"></el-option>
                      </el-select>
                    </div>
                    <div class="flex-1 text-center">
                      <el-input
                        v-if="item.prizeType == '1'"
                        style="width:140px"
                        v-model.trim="item.typeValue"
                        size="small"
                        clearable
                        placeholder="请输入奖品积分"
                      ></el-input>
                      <el-input
                        v-if="item.prizeType == '3'"
                        style="width:140px"
                        v-model.trim="item.typeValue"
                        size="small"
                        clearable
                        placeholder="请输入奖品实物名称"
                      ></el-input>
                      <el-select
                        v-if="item.prizeType == '2'"
                        clearable
                        class="mr10 "
                        size="small"
                        v-model="item.typeValue"
                        placeholder="请选择优惠券"
                      >
                        <el-option label="优惠券1" value="11"></el-option>
                        <el-option label="优惠券2" value="22"></el-option>
                        <el-option label="优惠券3" value="33"></el-option>
                      </el-select>
                    </div>
                    <div class="flex-1 text-center">
                      <el-input
                        style="width:140px"
                        v-model.trim="item.prizeName"
                        size="small"
                        clearable
                        placeholder="请输入奖品名称"
                      ></el-input>
                    </div>
                    <div class="flex-1 text-center">
                      <el-input
                        style="width:100px"
                        v-model.trim="item.prizeNum"
                        size="small"
                        placeholder="请输入数字"
                      ></el-input>
                    </div>

                    <div class="flex-1 text-center">
                      <el-input
                        style="width:100px"
                        v-model.trim="item.prizePriority"
                        size="small"
                        placeholder="请输入数字"
                      ></el-input>
                    </div>
                    <div class="flex-1">
                      <div
                        class="add-wrapper flex flex-center"
                        v-if="index === 0"
                      >
                        <span
                          class="hmicon icon-hao pointer"
                          @click="addChild(index)"
                        ></span>
                      </div>
                      <div class="minus-wrapper flex flex-center" v-else>
                        <span
                          class="hmicon icon-jianhao pointer"
                          @click="deleteChild(index)"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="预计参与次数" prop="estimatedNum"
              ><el-input
                style="width: 100px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.estimatedNum"
                placeholder="请输入次数"
              ></el-input
              >次
            </el-form-item>
            <div id="gameAstrict">{{ steps.length === 3 ? 3 : 3 }}活动限制</div>
            <el-form-item label="活动参与门槛" prop="eachConsumIntegral">
              <span>每次消耗积分</span
              ><el-input
                style="width: 130px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="threshold.eachConsumIntegral"
                placeholder="请输入积分数值"
              ></el-input>
            </el-form-item>
            <div class="flex flex-center">
              <el-button size="small" type="success" @click="sample"
                >预览</el-button
              >
              <el-button
                type="primary"
                size="small"
                @click="submitForm('ruleForm')"
                >发布</el-button
              >
              <el-button size="small" @click="$router.back(-1)">返回</el-button>
            </div>
          </el-form>
        </div>

        <div class=""></div>
      </el-scrollbar>
      <el-dialog
        :close-on-click-modal="false"
        title="批量设置"
        :visible.sync="dialogVisible"
      >
        <div class=" flex flex-center">
          <div id="audio_btn" class="rotate">
            <audio
              :src="ruleForm.gameBgm"
              autoplay="true"
              loop="loop"
              id="media"
              preload="true"
            ></audio>
          </div>
          <img
            class="pvwimg"
            style="width:400px;height:667px"
            :src="listHeaderImgUrl"
            alt=""
          />
          <p>已有 {{ 0 }}人参与</p>
          <p>您今天还有 {{ 3 }}次抽奖机会</p>
        </div>
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      listHeaderUrl: `http://192.168.188.169:6060/sys/common/upload/oss`,
      listHeaderImgUrl: "",
      storeId: "",
      currentStep: 1,
      scrollHeight: 0,
      show: false,
      dialogVisible: false,
      steps: [
        {
          id: "base",
          name: "基本信息"
        },
        {
          id: "gameRule",
          name: "活动规则"
        },
        {
          id: "gameAstrict",
          name: "活动限制"
        }
      ],
      ruleForm: {
        gameName: "",
        gameRuleRemark: "",
        gameShareContent: "",
        gameBgm: "",
        visualJoinNum: ""
      },
      rule: {
        drawType: "total",
        turntablePrizeRuleList: [
          {
            rankingSeqNum: "",
            prizeType: "1",
            typeValue: "",
            prizeName: "",
            prizeNum: "",
            prizePriority: ""
          }
        ]
      },
      threshold: {
        eachConsumIntegral: ""
      },
      rules: {},
      actDesc: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.calcHeight();
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toggleShow() {
      this.show = !this.show;
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    addChild() {
      this.rule.turntablePrizeRuleList.push({
        specName: "",
        specValue: "",
        specImg: ""
      });
    },
    deleteChild(index) {
      this.rule.turntablePrizeRuleList.splice(index, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          this.ruleForm.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";

          let params = this.ruleForm;
          params.gameType = "1";
          params.gameBgp = this.listHeaderImgUrl;
          if (this.rule.drawType == "daily") {
            this.rule.drawPrizeNum = this.rule.drawPrizeNumDaily;
            this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitDaily;
          } else {
            this.rule.drawPrizeNum = this.rule.drawPrizeNumTotal;
            this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitTotal;
          }

          params = Object.assign(params, {
            rule: this.rule,
            threshold: this.threshold
          });

          this.$store.dispatch("addTurntable", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    sample() {
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="scss">
.game-select {
  .el-select {
    width: 140px !important;
    .el-input {
      width: 140px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.pvw {
  .pvws {
    width: 400px;
    height: 667px;
    margin-right: 100px;
    position: relative;
    .describe {
      position: absolute;
      bottom: 10px;
      p {
        text-align: center;
      }
    }
  }
  #audio_btn {
    position: absolute;
    left: 10px;
    top: 10px;
    z-index: 999999;
    width: 45px;
    height: 45px;
    background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/ico_music.png");
    background-size: contain;
    background-repeat: no-repeat;
  }
  .rotate {
    -webkit-animation: rotating 1.2s linear infinite;
    -moz-animation: rotating 1.2s linear infinite;
    -o-animation: rotating 1.2s linear infinite;
    animation: rotating 1.2s linear infinite;
  }

  .pvwimg {
    position: fixed;
    top: 200px;
  }
}
.table {
  border: 1px solid #ddd;
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
.priview {
  position: relative;
  width: 400px;
  height: 667px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
